import router from './router'
import useRedirectRulesStore from './store'
import RedirectRulesMessages from './localization'

export default {
  router,
  useRedirectRulesStore,
  localization: RedirectRulesMessages,
}
